export default __webpack_public_path__ + "static/media/strPrm.21ea379a.png";